/**
 * @generated SignedSource<<285110ef1db24c777c9bd56d3f73e053>>
 * @relayHash 548231ba018abfd89492c245744ab3bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 065fb14eb6fa7afe0e87da8fc1de52d041df6560154341356fdf93a2be5d4206

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overview_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type overview_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview" | "agentIdentity_AtlassianCsmAgentIdentity">;
    } | null | undefined;
  } | null | undefined;
};
export type overview_agentIdentityQuery = {
  response: overview_agentIdentityQuery$data;
  variables: overview_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentCard_AtlassianCsmAgentOverview"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "agentIdentity_AtlassianCsmAgentIdentity"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyDescription"
                      },
                      {
                        "concreteType": "CsmAiAgentTone",
                        "kind": "LinkedField",
                        "name": "tone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "greetingMessage"
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "065fb14eb6fa7afe0e87da8fc1de52d041df6560154341356fdf93a2be5d4206",
    "metadata": {},
    "name": "overview_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3d24560bfcc85ddde9991290d72044c3";

export default node;
